/**
 * Ory Kratos UI message IDs.
 *
 * Source: https://www.ory.com/docs/kratos/concepts/ui-messages
 */

// Info messages — sign in flow (1010xxx)
export const BIFROST_MSG_SIGN_IN = 1010001;
export const BIFROST_MSG_SIGN_IN_WITH_PROVIDER = 1010002;
export const BIFROST_MSG_CONFIRM_ACTION = 1010003;
export const BIFROST_MSG_SECOND_CHALLENGE = 1010004;
export const BIFROST_MSG_VERIFY = 1010005;
export const BIFROST_MSG_AUTHENTICATION_CODE = 1010006;
export const BIFROST_MSG_BACKUP_RECOVERY_CODE_LABEL = 1010007;
export const BIFROST_MSG_SIGN_IN_HARDWARE_KEY = 1010008;
export const BIFROST_MSG_USE_AUTHENTICATOR = 1010009;
export const BIFROST_MSG_USE_BACKUP_CODE = 1010010;
export const BIFROST_MSG_SIGN_IN_HARDWARE_KEY_2 = 1010011;
export const BIFROST_MSG_PREPARE_WEBAUTHN = 1010012;
export const BIFROST_MSG_CONTINUE = 1010013;
export const BIFROST_MSG_CODE_SENT = 1010014;
export const BIFROST_MSG_SEND_SIGN_IN_CODE = 1010015;
export const BIFROST_MSG_DUPLICATE_IDENTIFIER = 1010016;
export const BIFROST_MSG_SIGN_IN_AND_LINK = 1010017;
export const BIFROST_MSG_CONFIRM_WITH_PROVIDER = 1010018;
export const BIFROST_MSG_REQUEST_CODE = 1010019;
export const BIFROST_MSG_SIGN_IN_WITH_PASSKEY = 1010021;
export const BIFROST_MSG_SIGN_IN_WITH_PASSWORD = 1010022;
export const BIFROST_MSG_SEND_CODE_TO_ADDRESS = 1010023;
export const BIFROST_MSG_SIGN_IN_HARDWARE_KEY_3 = 1010024;

// Info messages — sign up flow (1040xxx)
export const BIFROST_MSG_SIGN_UP = 1040001;
export const BIFROST_MSG_SIGN_UP_WITH_PROVIDER = 1040002;
export const BIFROST_MSG_SIGN_UP_CONTINUE = 1040003;
export const BIFROST_MSG_SIGN_UP_SECURITY_KEY = 1040004;
export const BIFROST_MSG_SIGN_UP_CODE_SENT = 1040005;
export const BIFROST_MSG_SEND_SIGN_UP_CODE = 1040006;
export const BIFROST_MSG_SIGN_UP_WITH_PASSKEY = 1040007;
export const BIFROST_MSG_SIGN_UP_BACK = 1040008;
export const BIFROST_MSG_CHOOSE_CREDENTIAL = 1040009;

// Info messages — settings flow (1050xxx)
export const BIFROST_MSG_CHANGES_SAVED = 1050001;
export const BIFROST_MSG_LINK_PROVIDER = 1050002;
export const BIFROST_MSG_UNLINK_PROVIDER = 1050003;
export const BIFROST_MSG_UNLINK_TOTP = 1050004;
export const BIFROST_MSG_TOTP_QR_CODE = 1050005;
export const BIFROST_MSG_TOTP_SECRET = 1050006;
export const BIFROST_MSG_REVEAL_BACKUP_CODES = 1050007;
export const BIFROST_MSG_GENERATE_BACKUP_CODES = 1050008;
export const BIFROST_MSG_BACKUP_CODE_ITEM = 1050009;
export const BIFROST_MSG_BACKUP_CODES_WARNING = 1050010;
export const BIFROST_MSG_CONFIRM_BACKUP_CODES = 1050011;
export const BIFROST_MSG_ADD_SECURITY_KEY = 1050012;
export const BIFROST_MSG_SECURITY_KEY_NAME = 1050013;
export const BIFROST_MSG_SECRET_USED_AT = 1050014;
export const BIFROST_MSG_SECRETS_LIST = 1050015;
export const BIFROST_MSG_DISABLE_METHOD = 1050016;
export const BIFROST_MSG_TOTP_SECRET_INSTRUCTION = 1050017;
export const BIFROST_MSG_REMOVE_SECURITY_KEY = 1050018;
export const BIFROST_MSG_ADD_PASSKEY = 1050019;
export const BIFROST_MSG_REMOVE_PASSKEY = 1050020;

// Info messages — recovery flow (1060xxx)
export const BIFROST_MSG_RECOVERY_SUCCESS = 1060001;
export const BIFROST_MSG_RECOVERY_EMAIL_SENT_LINK = 1060002;
export const BIFROST_MSG_RECOVERY_EMAIL_SENT_CODE = 1060003;
export const BIFROST_MSG_RECOVERY_CODE_SENT = 1060004;
export const BIFROST_MSG_RECOVERY_ADDRESS_FULL = 1060005;
export const BIFROST_MSG_RECOVERY_HOW = 1060006;
export const BIFROST_MSG_RECOVERY_BACK = 1060007;

// Info messages — shared node labels (1070xxx)
export const BIFROST_MSG_LABEL_PASSWORD = 1070001;
export const BIFROST_MSG_LABEL_TITLE = 1070002;
export const BIFROST_MSG_LABEL_SAVE = 1070003;
export const BIFROST_MSG_LABEL_ID = 1070004;
export const BIFROST_MSG_LABEL_SUBMIT = 1070005;
export const BIFROST_MSG_LABEL_VERIFY_CODE = 1070006;
export const BIFROST_MSG_LABEL_EMAIL = 1070007;
export const BIFROST_MSG_LABEL_RESEND_CODE = 1070008;
export const BIFROST_MSG_LABEL_CONTINUE = 1070009;
export const BIFROST_MSG_LABEL_RECOVERY_CODE = 1070010;
export const BIFROST_MSG_LABEL_VERIFICATION_CODE = 1070011;
export const BIFROST_MSG_LABEL_REGISTRATION_CODE = 1070012;
export const BIFROST_MSG_LABEL_LOGIN_CODE = 1070013;
export const BIFROST_MSG_LABEL_LOGIN_LINK_CREDENTIAL = 1070014;
export const BIFROST_MSG_LABEL_CAPTCHA = 1070015;
export const BIFROST_MSG_LABEL_RECOVERY_ADDRESS = 1070016;
export const BIFROST_MSG_LABEL_PHONE_NUMBER = 1070017;
export const BIFROST_MSG_LABEL_EMAIL_OR_PHONE = 1070018;

// Info messages — verification flow (1080xxx)
export const BIFROST_MSG_VERIFICATION_EMAIL_SENT_LINK = 1080001;
export const BIFROST_MSG_VERIFICATION_EMAIL_SUCCESS = 1080002;
export const BIFROST_MSG_VERIFICATION_EMAIL_SENT_CODE = 1080003;
export const BIFROST_MSG_VERIFICATION_SMS_SENT = 1080004;
export const BIFROST_MSG_VERIFICATION_PHONE_SUCCESS = 1080005;

// Error messages — general validation (4000xxx)
export const BIFROST_ERR_GENERIC = 4000001;
export const BIFROST_ERR_PROPERTY_MISSING = 4000002;
export const BIFROST_ERR_MIN_LENGTH = 4000003;
export const BIFROST_ERR_PATTERN_MISMATCH = 4000004;
export const BIFROST_ERR_PASSWORD_POLICY = 4000005;
export const BIFROST_ERR_INVALID_CREDENTIALS = 4000006;
export const BIFROST_ERR_IDENTIFIER_EXISTS = 4000007;
export const BIFROST_ERR_INVALID_AUTH_CODE = 4000008;
export const BIFROST_ERR_NO_LOGIN_IDENTIFIERS = 4000009;
export const BIFROST_ERR_ACCOUNT_NOT_ACTIVE = 4000010;
export const BIFROST_ERR_NO_TOTP_DEVICE = 4000011;
export const BIFROST_ERR_BACKUP_CODE_USED = 4000012;
export const BIFROST_ERR_NO_WEBAUTHN_DEVICE = 4000013;
export const BIFROST_ERR_NO_BACKUP_CODES = 4000014;
export const BIFROST_ERR_NO_SECURITY_KEY = 4000015;
export const BIFROST_ERR_INVALID_BACKUP_CODE = 4000016;
export const BIFROST_ERR_MAX_LENGTH = 4000017;
export const BIFROST_ERR_MIN_VALUE = 4000018;
export const BIFROST_ERR_MIN_VALUE_EXCLUSIVE = 4000019;
export const BIFROST_ERR_MAX_VALUE = 4000020;
export const BIFROST_ERR_MAX_VALUE_EXCLUSIVE = 4000021;
export const BIFROST_ERR_MULTIPLE_OF = 4000022;
export const BIFROST_ERR_MAX_ITEMS = 4000023;
export const BIFROST_ERR_MIN_ITEMS = 4000024;
export const BIFROST_ERR_DUPLICATE_ITEMS = 4000025;
export const BIFROST_ERR_WRONG_TYPE = 4000026;
export const BIFROST_ERR_IDENTIFIER_EXISTS_LINK_SOCIAL = 4000027;
export const BIFROST_ERR_CREDENTIAL_IN_USE = 4000028;
export const BIFROST_ERR_CONST_EXPECTED = 4000029;
export const BIFROST_ERR_CONST_FAILED = 4000030;
export const BIFROST_ERR_PASSWORD_TOO_SIMILAR = 4000031;
export const BIFROST_ERR_PASSWORD_TOO_SHORT = 4000032;
export const BIFROST_ERR_PASSWORD_TOO_LONG = 4000033;
export const BIFROST_ERR_PASSWORD_IN_BREACH = 4000034;
export const BIFROST_ERR_NO_CODE_SIGN_IN = 4000035;
export const BIFROST_ERR_TRAITS_MISMATCH = 4000036;
export const BIFROST_ERR_NO_LOGIN_METHOD = 4000037;
export const BIFROST_ERR_CAPTCHA_FAILED = 4000038;
export const BIFROST_ERR_PASSWORD_SAME = 4000039;
export const BIFROST_ERR_INVALID_EMAIL = 4000040;
export const BIFROST_ERR_INVALID_PHONE = 4000041;
export const BIFROST_ERR_NO_DEVICE_AUTHN = 4000042;
export const BIFROST_ERR_INVALID_WEBAUTHN = 4000043;
export const BIFROST_ERR_INVALID_DEVICE_AUTHN = 4000044;

// Error messages — login flow (4010xxx)
export const BIFROST_ERR_LOGIN_FLOW_EXPIRED = 4010001;
export const BIFROST_ERR_LOGIN_NO_STRATEGY = 4010002;
export const BIFROST_ERR_REGISTRATION_NO_STRATEGY = 4010003;
export const BIFROST_ERR_SETTINGS_NO_STRATEGY = 4010004;
export const BIFROST_ERR_RECOVERY_NO_STRATEGY = 4010005;
export const BIFROST_ERR_VERIFICATION_NO_STRATEGY = 4010006;
export const BIFROST_ERR_ALREADY_COMPLETED = 4010007;
export const BIFROST_ERR_LOGIN_CODE_INVALID = 4010008;
export const BIFROST_ERR_LINKED_CREDENTIALS_MISMATCH = 4010009;
export const BIFROST_ERR_ADDRESS_NOT_FOUND = 4010010;
export const BIFROST_ERR_ACCOUNT_DISABLED = 4010011;

// Error messages — registration flow (4040xxx)
export const BIFROST_ERR_REGISTRATION_FLOW_EXPIRED = 4040001;
export const BIFROST_ERR_REGISTRATION_ALREADY_COMPLETED = 4040002;
export const BIFROST_ERR_REGISTRATION_CODE_INVALID = 4040003;

// Error messages — settings flow (4050xxx)
export const BIFROST_ERR_SETTINGS_FLOW_EXPIRED = 4050001;
export const BIFROST_ERR_SETTINGS_ONE_ADDRESS_AT_A_TIME = 4050002;

// Error messages — recovery flow (4060xxx)
export const BIFROST_ERR_RECOVERY_ALREADY_COMPLETED = 4060001;
export const BIFROST_ERR_RECOVERY_FLOW_FAILED = 4060002;
export const BIFROST_ERR_RECOVERY_TOKEN_INVALID = 4060004;
export const BIFROST_ERR_RECOVERY_FLOW_EXPIRED = 4060005;
export const BIFROST_ERR_RECOVERY_CODE_INVALID = 4060006;

// Error messages — verification flow (4070xxx)
export const BIFROST_ERR_VERIFICATION_TOKEN_INVALID = 4070001;
export const BIFROST_ERR_VERIFICATION_ALREADY_COMPLETED = 4070002;
export const BIFROST_ERR_VERIFICATION_FLOW_FAILED = 4070003;
export const BIFROST_ERR_VERIFICATION_FLOW_EXPIRED = 4070005;
export const BIFROST_ERR_VERIFICATION_CODE_INVALID = 4070006;

// Error messages — system errors (5000xxx)
export const BIFROST_ERR_SYSTEM_GENERIC = 5000001;
export const BIFROST_ERR_NO_AUTH_METHODS = 5000002;
export const BIFROST_ERR_SSO_REQUIRED = 5000003;

// Error messages - Republic custom errors (1xxx)
export const BIFROST_ERR_SESSION_NOT_PRIVILEGED = 1009;
export const BIFROST_ERR_INSUFFICIENT_AAL = 1010;
